export default __webpack_public_path__ + "images/JH.6e8d35b.png";